import { ComponentRef, Injectable } from '@angular/core';
import { IUserLoginCustomerSelectDialogService } from 'projects/shared/lib/interfaces/services/dialogs/user-login-customer-select-dialog-service.abstract';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { UserLoginCustomerSelectDialogComponent } from 'projects/shared/lib/components/shared/user/user-login-customer-select-dialog/user-login-customer-select-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UserLoginCustomerSelectDialogService implements IUserLoginCustomerSelectDialogService {

  userLoginCustomerSelectDialogShow(
    callbackClose: () => void,
  ): void {

    DialogBaseService.dialogGenericShow(
      UserLoginCustomerSelectDialogComponent,
      (componentRef: ComponentRef<UserLoginCustomerSelectDialogComponent>) => {
        let component = componentRef.instance;

        component.modalClose.subscribe(
          () => {
            callbackClose();
            DialogBaseService.dynamicComponentRemove(componentRef);
          }
        );

      }
    );
  }

}
